import type { ReactNode } from 'react'
import React, { useEffect } from 'react'
import { DelimitedArrayParam, StringParam, useQueryParams } from 'use-query-params'

import { useProducts } from './useProducts/useProducts'

type UseAdditionalProductsParams = {
  onCreated: (props: { message: ReactNode }) => void
}

export const useAdditionalProducts = ({ onCreated }: UseAdditionalProductsParams) => {
  const { products, isLoading } = useProducts()
  const [query, setQuery] = useQueryParams({
    originOfferId: StringParam,
    additionalOffersIds: DelimitedArrayParam,
  })

  useEffect(() => {
    if (isLoading) {
      return
    }

    const originOfferId = query.originOfferId
    const originProduct = products.find((product) => product.id === originOfferId)
    const additionalOffersLength = query.additionalOffersIds?.length

    if (!originProduct || !additionalOffersLength) {
      return
    }

    const pluralizedProductText =
      additionalOffersLength > 1
        ? `additional products created successfully`
        : 'additional product created successfully'

    const message = (
      <p>
        <strong>"{originProduct.name}"</strong> and <strong>{additionalOffersLength}</strong>{' '}
        {pluralizedProductText}
      </p>
    )

    onCreated({ message })

    setQuery({ originOfferId: undefined, additionalOffersIds: undefined })
  }, [isLoading, onCreated, products, query, setQuery])
}
